import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import { Card, AuthComponent, GridForm, Input, Button, NetworkLoader } from '../components';
import { AuthDelegate, FormDelegate, formValidators } from '../utils';
import { routes, fetchTypes, requestStatus } from '../constants';
import { RouteActions, ResourceActions } from '../actions';

class ForgotPasswordPage extends AuthComponent {
    constructor(props) {
        super(props);

        this.formDelegate = new FormDelegate();
        this.formDelegate.onChange((output, valid, inputs) => this.changeHandler(output, valid, inputs));
        this.formDelegate.onSubmit((output, valid, inputs) => this.submitHandler(output, valid, inputs));

        this.state = {
            errors: [],
            tryAgain: false,
            formData: {
                email: ''
            }
        }
    }

    componentWillMount(){
        super.componentWillMount();
        RouteActions.setAppState(routes.FORGOT_PASSWORD);
    }

    userIsAuthorized(user) {
        return AuthDelegate.userIsLoggedIn(false)(user);
    }

    componentWillRejectUser() {
        browserHistory.push(routes.RESET_PASSWORD);
    }

    changeHandler(output, valid) {
        let newState = {
            errors: this.formDelegate.getErrors()
        };

        if (valid) {
            newState.formData = output;
        }

        this.setState(newState);
    }

    submitHandler(output, valid) {
        this.setState({
            errors: this.formDelegate.getErrors()
        });

        if (valid) {
            this.setState({
                tryAgain: false
            }, () => {
                this.props.dispatch(ResourceActions.resourceFetch(fetchTypes.FORGOT_PASSWORD, this.state.formData));
            });
        }
    }

    tryAgain() {
        this.setState({
            tryAgain: true,
            formData: {
                email: ''
            }
        });
    }

    forgotPasswordForm() {
        let errMsg = this.state.errors[0] ? this.state.errors[0].message : '';

        return (
            <div className="card-body">
                <p>
                    Please enter the email associated with your account.
                </p>
                <form onSubmit={e => this.formDelegate.submit(e)}>
                    <GridForm>
                        <div className="form-group">
                            <label className="form-control">Email</label>
                            <Input defaultValue={this.state.formData.email} className="form-control" name="email" delegate={this.formDelegate} validators={formValidators.email({ message: 'Please enter a valid email address.' })} type="text" />
                        </div>
                    </GridForm>
                    <NetworkLoader status={this.props.passwordRecovery.status}>
                        <div className="form-footer">
                            <div className="form-error">{errMsg}</div>
                            <Button className="primary" type="submit">Submit</Button>
                        </div>
                    </NetworkLoader>
                </form>
            </div>
        );
    }

    completeView() {
        return (
            <div className="card-body">
                <p className="notification-text">We sent you an email with a link to reset your password. </p>
                <Button onClick={e => this.formDelegate.submit(e)}>Resend</Button>
                <Button onClick={() => this.tryAgain() }>Try a Different Email</Button>
            </div>
        );
    }

    renderBody() {
        let status = this.props.passwordRecovery.status;

        if (status === requestStatus.COMPLETE && this.state.tryAgain === false) {
            return this.completeView();
        } else {
            return this.forgotPasswordForm();
        }
    }

    authRender () {

        return (
            <div className="container component-login-widget" id="container-forgot-password">
                <div className="row center-cols">
                    <div className="col-md-6 col-lg-5 center">
                        <Card>
                            <div className="card-title-area">
                                <h3>Recover Your Password</h3>
                            </div>
                            { this.renderBody() }
                        </Card>
                    </div>
                </div>
            </div>
        )
    }
}

function select(state) {
    return {
        user: state.activeUser,
        passwordRecovery: state.passwordRecoveryStatus
    }
}

export default connect(select)(ForgotPasswordPage);



// WEBPACK FOOTER //
// ./web-app/containers/forgot-password.jsx